module.exports = __webpack_public_path__ + "static/media/phaser-dude.39a24a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/sprites/phaser-dude.png
// module id = 2727
// module chunks = 0